import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class FiscalInventoryValuation  {
    _originalTypeClassName = "zERP.BO.FiscalInventoryValuation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
FiscalInventoryValuation.translate = translateService;
}
this.Goods = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Goods:any;
FiscalYear:any;
static setGoods = ($this, items) => {
                if (items == null) items = [];
                if ($this.Goods == null) $this.Goods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Goods.length > 0) {
                    Domain.FiscalInventoryValuation.removeGoods($this, $this.Goods[0]);
                }

                Domain.FiscalInventoryValuation.addManyGoods($this, copyItems);
            }
static addManyGoods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.FiscalInventoryValuation.addGoods($this, items[i]);
                }
            }
static addGoods = ($this, item) => {
                if ($this.Goods == null) $this.Goods = [];
                if (item == null || $this.Goods.indexOf(item) > -1) return;
                $this.Goods.push(item);
}
static addRangeGoods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.FiscalInventoryValuation.addGoods($this, item));
            }
static removeGoods = ($this, item) => {
                if ($this == null || $this.Goods == null || $this.Goods.indexOf(item) === -1) return;
                var _index = $this.Goods.indexOf(item);
                $this.Goods.splice(_index, 1);
}
static clearGoods = ($this) => { $this.Goods = null; }
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}